import config from "../config/app.conf.json";

export default () => ({
  url: config.api.signed_up_users,
  method: "GET"
});
